"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.MEDIA_STATUS = void 0;

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer.scss"));

var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));

var _SkipPrevious = _interopRequireDefault(require("@material-ui/icons/SkipPrevious"));

var _SkipNext = _interopRequireDefault(require("@material-ui/icons/SkipNext"));

var _Forward = _interopRequireDefault(require("@material-ui/icons/Forward10"));

var _Forward2 = _interopRequireDefault(require("@material-ui/icons/Forward30"));

var _Replay = _interopRequireDefault(require("@material-ui/icons/Replay10"));

var _Replay2 = _interopRequireDefault(require("@material-ui/icons/Replay30"));

var _AudioBar = _interopRequireDefault(require("./AudioBar"));

var _PauseCircleFilled = _interopRequireDefault(require("@material-ui/icons/PauseCircleFilled"));

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _ListenedSequences = _interopRequireDefault(require("../DrupalTiles/Nuggets/ListenedSequences2"));

// @ts-ignore
var MEDIA_STATUS = {
  NONE: 0,
  STARTING: 1,
  RUNNING: 2,
  PAUSED: 3,
  STOPPED: 4
};
exports.MEDIA_STATUS = MEDIA_STATUS;

function AudioPlayer(props) {
  var _media$current16;

  var barColor = props.barColor,
      domId = props.domId,
      backgroundColor = props.backgroundColor,
      playlist = props.playlist,
      nugget = props.nugget;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      playingIndex = _useState2[0],
      setPlayingIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      playingTitle = _useState4[0],
      setPlayingTitle = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      playerState = _useState6[0],
      setPlayerState = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      currentTime = _useState8[0],
      setCurrentTime = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      prevTime = _useState10[0],
      setPrevTime = _useState10[1];

  var currentTimeRef = (0, _react.useRef)(0);
  var media = (0, _react.useRef)(null);
  var indexRef = (0, _react.useRef)(0);
  var playerStateRef = (0, _react.useRef)(0);
  var setIndexRef = (0, _react.useRef)(setPlayingIndex);
  var playingTitleRef = (0, _react.useRef)('');
  var intervalRef = (0, _react.useRef)();
  currentTimeRef.current = currentTime;
  indexRef.current = playingIndex;
  playingTitleRef.current = playingTitle;
  setIndexRef.current = setPlayingIndex;
  playerStateRef.current = playerState;
  (0, _react.useEffect)(function () {
    console.log('useEffect', playerState);

    if (playerState === MEDIA_STATUS.RUNNING) {
      window.MusicControls.updateElapsed({
        elapsed: currentTime,
        isPlaying: true
      });
      intervalRef.current = setInterval(function () {
        var _media$current;

        (_media$current = media.current) === null || _media$current === void 0 ? void 0 : _media$current.getCurrentPosition(function (pos) {
          setCurrentTime(pos);
        });
      }, 1000);
    } else if (playerState === MEDIA_STATUS.PAUSED) {
      // window.MusicControls.updateIsPlaying(false)
      if (intervalRef.current) clearInterval(intervalRef.current);
      window.MusicControls.updateElapsed({
        elapsed: currentTime,
        isPlaying: false
      });
    } else if (playerState === MEDIA_STATUS.STOPPED) {
      var _media$current2;

      window.MusicControls.updateIsPlaying(false);
      if (intervalRef.current) clearInterval(intervalRef.current);
      var duration = (_media$current2 = media.current) === null || _media$current2 === void 0 ? void 0 : _media$current2.getDuration();
      console.log('useEffect', playerState, duration, currentTime);

      if (duration > 0 && Math.abs(duration - currentTime) < 5) {
        playNextTrack();
      }
    }
  }, [playerState]);
  (0, _react.useEffect)(function () {
    if (playlist && playlist.length > 0) {
      playTrack(0, playlist[0].title, true);
    }

    return function () {
      return removeListeners();
    };
  }, []);

  var createMusicControl = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(title) {
      var tries,
          onSuccess,
          onError,
          duration,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tries = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;

              onSuccess = function onSuccess() {
                console.log('MusicControls onSuccess');
              };

              onError = function onError() {
                console.log('MusicControls error');
              };

              duration = media.current.getDuration();

              if (!(_DeviceInfoHelper["default"].isiOS() && duration === -1 && tries > -1)) {
                _context.next = 11;
                break;
              }

              console.log('duration not yet set!', tries);
              _context.next = 8;
              return (0, _TimeoutHelper.timeout)(500);

            case 8:
              createMusicControl(title, tries - 1);
              _context.next = 14;
              break;

            case 11:
              window.MusicControls.create({
                track: title,
                cover: _DeviceInfoHelper["default"].isBrowser() ? props.background : "".concat(filePath).concat(props.background),
                isPlaying: true,
                // optional, default : true
                dismissable: true,
                // optional, default : false
                // hide previous/next/close buttons:
                hasPrev: indexRef.current > 0,
                // show previous button, optional, default: true
                hasNext: playlist.length - 1 > indexRef.current,
                // show next button, optional, default: true
                hasClose: true,
                // show close button, optional, default: false
                // iOS only, optional
                duration: duration || 0,
                // optional, default: 0
                elapsed: currentTimeRef.current || 0,
                // hasSkipForward : true, //optional, default: false. true value overrides hasNext.
                // hasSkipBackward : true, //optional, default: false. true value overrides hasPrev.
                // skipForwardInterval : 15, //optional. default: 0.
                // skipBackwardInterval : 15, //optional. default: 0.
                hasScrubbing: true,
                //optional. default to false. Enable scrubbing from control center progress bar
                // Android only, optional
                // text displayed in the status bar when the notification (and the ticker) are updated
                ticker: title,
                //All icons default to their built-in android equivalents
                //The supplied drawable name, e.g. 'media_play', is the name of a drawable found under android/res/drawable* folders
                playIcon: 'media_play',
                pauseIcon: 'media_pause',
                prevIcon: 'media_prev',
                nextIcon: 'media_next',
                closeIcon: 'media_close',
                notificationIcon: 'notification'
              }, onSuccess, onError);
              window.MusicControls.subscribe(events);
              window.MusicControls.listen();

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createMusicControl(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var removeListeners = function removeListeners() {
    if (window.MusicControls) {
      var onSuccess = function onSuccess() {
        console.log('MusicControls onSuccess');
      };

      var onError = function onError() {
        console.log('MusicControls error');
      };

      window.MusicControls.destroy(onSuccess, onError);
    }
  };

  var resetTrack = function resetTrack() {
    var _media$current3;

    var prevTime = currentTimeRef.current;
    setPrevTime(prevTime);
    setCurrentTime(0);
    (_media$current3 = media.current) === null || _media$current3 === void 0 ? void 0 : _media$current3.seekTo(0);
  };

  var events = function events(action) {
    var _media$current4, _media$current5, _media$current6, _media$current7;

    var message = JSON.parse(action).message;

    switch (message) {
      case 'music-controls-next':
        (_media$current4 = media.current) === null || _media$current4 === void 0 ? void 0 : _media$current4.stop();
        playNextTrack();
        break;

      case 'music-controls-previous':
        playPreviousTrack();
        break;

      case 'music-controls-pause':
        window.MusicControls.updateIsPlaying(false);
        (_media$current5 = media.current) === null || _media$current5 === void 0 ? void 0 : _media$current5.pause();
        break;

      case 'music-controls-play':
        window.MusicControls.updateIsPlaying(true);
        (_media$current6 = media.current) === null || _media$current6 === void 0 ? void 0 : _media$current6.play();
        break;

      case 'music-controls-destroy':
        (_media$current7 = media.current) === null || _media$current7 === void 0 ? void 0 : _media$current7.release();
        break;

      case 'music-controls-skip-forward':
        skipTime(15);
        break;

      case 'music-controls-skip-backward':
        skipTime(-15);
        break;

      case 'music-controls-seek-to':
        var seekToInSeconds = JSON.parse(action).position;
        setClickedTime(seekToInSeconds); // Do something

        break;

      case 'music-controls-toggle-play-pause':
        if (playerStateRef.current === MEDIA_STATUS.RUNNING) {
          var _media$current8;

          window.MusicControls.updateIsPlaying(false);
          (_media$current8 = media.current) === null || _media$current8 === void 0 ? void 0 : _media$current8.pause();
        } else {
          var _media$current9;

          window.MusicControls.updateIsPlaying(true);
          (_media$current9 = media.current) === null || _media$current9 === void 0 ? void 0 : _media$current9.play();
        }

        break;

      default:
        break;
    }
  };

  var getAudioTitle = function getAudioTitle(index) {
    var title = 'Podcast';
    var item = playlist[index];

    if (item) {
      if (item.title) {
        title = item.title;
      } else if (item.name) {
        title = item.name;
      } else if (item.info) {
        title = item.info;
      } else {
        title = _config["default"].defaultPodcastTitle;
      }
    }

    return title;
  };

  var playTrack = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(index, title) {
      var isInitialSetting,
          trackUrl,
          _media$current10,
          onSuccess,
          onError,
          _media$current11,
          audioInfo,
          _media$current12,
          _args2 = arguments;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isInitialSetting = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              trackUrl = playlist.length > index && playlist[index].audioFile;

              if (trackUrl) {
                if (indexRef.current !== index || isInitialSetting) {
                  // make sure prev audio is stopped!
                  (_media$current10 = media.current) === null || _media$current10 === void 0 ? void 0 : _media$current10.release(); // @ts-ignore

                  onSuccess = function onSuccess() {
                    console.log('playing media');
                  };

                  onError = function onError(err) {
                    console.log('error playing media', err);
                  };

                  media.current = new Media(trackUrl, onSuccess, onError, setCurrentStatus);
                  setIndexRef.current(index);
                }

                if (!isInitialSetting) {
                  media.current && ((_media$current11 = media.current) === null || _media$current11 === void 0 ? void 0 : _media$current11.play());

                  if (window.MusicControls) {
                    audioInfo = getAudioTitle(index);
                    createMusicControl(audioInfo);
                  }
                }
              } else {
                media.current && ((_media$current12 = media.current) === null || _media$current12 === void 0 ? void 0 : _media$current12.pause());
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function playTrack(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var setCurrentStatus = function setCurrentStatus(status) {
    setPlayerState(status);
  };

  var pauseAudio = function pauseAudio() {
    var _media$current13;

    (_media$current13 = media.current) === null || _media$current13 === void 0 ? void 0 : _media$current13.pause();
  };

  var skipTime = function skipTime(time) {
    var _media$current14;

    var prevTime = currentTimeRef.current;
    var newTime = currentTimeRef.current + time;
    setCurrentTime(newTime);

    if (playerState === MEDIA_STATUS.RUNNING) {
      setPrevTime(prevTime);
    }

    (_media$current14 = media.current) === null || _media$current14 === void 0 ? void 0 : _media$current14.seekTo(newTime * 1000);
    setPrevTime(-1);
  };

  var playNextTrack = function playNextTrack() {
    var newIndex = indexRef.current + 1;

    if (playlist.length > newIndex && playlist.length > playingIndex) {
      setCurrentTime(0);
      playTrack(newIndex, playlist[newIndex].name);
    }
  };

  var playPreviousTrack = function playPreviousTrack() {
    if (!media.current) return;

    if (currentTimeRef.current >= 10) {
      resetTrack();
    } else {
      var newIndex = indexRef.current - 1;
      if (newIndex < 0) return resetTrack();
      playTrack(newIndex, playlist[newIndex].name);
    }
  };

  var setClickedTime = function setClickedTime(time) {
    var _media$current15;

    if (time < 0) {
      return;
    }

    var prevTime = currentTimeRef.current;
    console.log('setClickedTime', time, prevTime, playerState);
    setCurrentTime((0, _parseFloat2["default"])(time));
    setPrevTime(prevTime);
    (_media$current15 = media.current) === null || _media$current15 === void 0 ? void 0 : _media$current15.seekTo((0, _parseFloat2["default"])(time) * 1000);
    setPrevTime(-1);
  };

  var filePath = _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder();
  var playerContainerClassName = _AudioPlayer["default"].playerContainerNoImage;
  if (props.background) playerContainerClassName = _AudioPlayer["default"].playerContainerOverBackground;else if (props.info && _config["default"].centerPodcastPlayButtonOverInfo) playerContainerClassName = _AudioPlayer["default"].playerContainerOverInfo;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.info && !_config["default"].centerPodcastPlayButtonOverInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "infoContainer",
    style: {
      paddingBottom: '20px',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'info',
    dangerouslySetInnerHTML: {
      __html: props.info
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "player ".concat(_AudioPlayer["default"].audioContainer)
  }, _config["default"].audioPlayerShowTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: _AudioPlayer["default"].playingTitle
  }, playingTitle || 'Podcast'), props.background && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: 'Podcast Hintergrundbild',
    src: _DeviceInfoHelper["default"].isBrowser() ? props.background : "".concat(filePath).concat(props.background),
    className: _AudioPlayer["default"].backgroundImage
  }), props.info && _config["default"].centerPodcastPlayButtonOverInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "infoContainer ctnPodcastContent ".concat(_AudioPlayer["default"].backgroundImage),
    style: {
      paddingBottom: '20px',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'info',
    dangerouslySetInnerHTML: {
      __html: props.info
    }
  })), /*#__PURE__*/_react["default"].createElement(_ListenedSequences["default"], {
    currentTime: currentTimeRef.current,
    prevTime: prevTime,
    playerState: playerState,
    podcastNugget: nugget,
    currentTrack: playlist.length > indexRef.current ? playlist[indexRef.current].audioFile : null
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: playerContainerClassName
  }, /*#__PURE__*/_react["default"].createElement(_AudioBar["default"], {
    color: barColor,
    curTime: currentTimeRef.current || 0,
    duration: ((_media$current16 = media.current) === null || _media$current16 === void 0 ? void 0 : _media$current16.getDuration()) || 0,
    onTimeUpdate: function onTimeUpdate(time) {
      return setClickedTime(time);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _config["default"].showPodcastSkip10Button ? _AudioPlayer["default"].controlsContainer : _AudioPlayer["default"].controlsContainerNo10
  }, /*#__PURE__*/_react["default"].createElement(_SkipPrevious["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playPreviousTrack();
    }
  }), /*#__PURE__*/_react["default"].createElement(_Replay2["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(-30);
    }
  }), _config["default"].showPodcastSkip10Button && /*#__PURE__*/_react["default"].createElement(_Replay["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(-10);
    }
  }), playerStateRef.current === MEDIA_STATUS.RUNNING ? /*#__PURE__*/_react["default"].createElement(_PauseCircleFilled["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButton ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return pauseAudio();
    }
  }) : /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playTrack(indexRef.current, playingTitle);
    }
  }), _config["default"].showPodcastSkip10Button && /*#__PURE__*/_react["default"].createElement(_Forward["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(10);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Forward2["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(30);
    }
  }), /*#__PURE__*/_react["default"].createElement(_SkipNext["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playNextTrack();
    }
  })))), playlist.map(function (audio, index) {
    if (!audio.active || !audio.audioFile) return null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: domId + '_' + index,
      className: _AudioPlayer["default"].audioItem
    }, playingIndex === index && playerStateRef.current === MEDIA_STATUS.RUNNING ? /*#__PURE__*/_react["default"].createElement(_PauseCircleFilled["default"], {
      className: "podcastPlayButton ".concat(_AudioPlayer["default"].playlistPlayButton),
      onClick: function onClick() {
        return pauseAudio();
      }
    }) : /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
      className: "podcastPlayButton ".concat(_AudioPlayer["default"].playlistPlayButton),
      onClick: function onClick() {
        return playTrack(index, audio.name);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].infoContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].audioFileName
    }, audio.name), audio && audio.info && /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].audioFileInfo
    }, audio.info)));
  }));
}

var _default = AudioPlayer;
exports["default"] = _default;